const Report = (props) => {
  return (
    <div style={{ padding: "50px" }}>
      <div>レポート画面</div>
    </div>
  );
};

export default Report;
